module.exports = {"app.preparing":"準備消息"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/zh.json
// module id = 1108
// module chunks = 0